import React, { isValidElement } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import i18next from "i18next";
import clsx from "clsx";
import useStyles from "../../style/js-style/containers/doc-viewer/DocViewerTableStyle";
import { formatDate } from "services/common/Utils";
import DocViewerFromJson from "./DocViewerFromJson";
import EAIcon from "components/common/EAIcon";
import parse from 'html-react-parser';
import _ from 'lodash';

const StyledTableRow = (props) => {
  const { classes } = useStyles(props);
  return <TableRow className={classes.root} {...props} />;
};

const withoutTooltip = (item) => {
  return Array.isArray(item?.props?.children) || item?.props?.noTooltip;
};

const RealizedByBloc = ({ label, date }) => {
  const { classes } = useStyles();
  if (!date || isNaN(new Date(date).getTime())) {
    return null;
  }
  const isCustomLabel = [i18next.t("viewer.smartCheckLabelDate"), i18next.t("viewer.extractor.title")].includes(label);
  return (
    <>
      {isCustomLabel ? (
        <span className={classes.realizedByBlocText}>
          {`${i18next.t("viewer.customControlLabel")}, ${i18next.t(i18next.language === "fr" ? 'le' : 'on')} `}
        </span>
      ) : (
        <span className={classes.realizedByBlocText}>
          {`${i18next.t("viewer.realizedBy")} ${label} ${i18next.t(i18next.language === "fr" ? 'the' : 'on')} `}
        </span>
      )}
      <span>{formatDate(date)}</span>
    </>
  );
}

const DocViewerTable = ({ header, body, label, date, hideEmptyNotice = false }) => {
  const { classes } = useStyles();

  const getCellWidth = (index, rowLength) => {
    switch (rowLength) {
      case 2:
        return index === 0 ? 35 : 65;
      case 3:
        return index === 2 ? 10 : 45;
      case 4:
        return index === 3 ? 10 : index === 2 ? 40 : 25;
      default:
        return 100 / rowLength;
    }
  };

  return (
    <Table>
      {body ? (
        // With datas
        <>
          {header && (
            <TableHead>
              <TableRow>
                <TableCell
                  variant="head"
                  colSpan={body[0]?.length || 1}
                  className={classes.header}
                >
                  <div className={classes.headerRealizedBy}>
                    <span >{header}</span>
                    {label && date && (
                      <span >
                        <RealizedByBloc label={label} date={date} />
                      </span>
                    )}
                  </div>
                </TableCell>
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {body.map((row, index) => {
              // Check for separator row with optional title
              if (row[0]?.separator) {
                return (
                  <TableRow key={`separator-${index}`} className={classes.separatorRow}>
                    <TableCell colSpan={body[0]?.length || 1} className={classes.separator}>
                      {row[0]?.title && (
                        <div className={classes.separatorTitle}>{row[0].title}</div>
                      )}
                    </TableCell>
                  </TableRow>
                );
              }

              // Render normal rows
              return (
                <StyledTableRow key={index}>
                  {row.map((item, index2) => (
                    <TableCell
                      key={index2}
                      width={`${getCellWidth(index2, row.length)}%`}
                      className={index2 === 0 ? classes.tableCellDescribe : classes.tableCell}
                    >
                      {isValidElement(item) ? (
                        item
                      ) : withoutTooltip(item) ? (
                        item
                      ) : Array.isArray(item) ? (
                        item.some((el) => typeof el === "object" && el !== null) ? (
                          // If at least one element is an object, use JsonViewer
                          <DocViewerFromJson body={item} style={{ marginTop: "-12px", marginBottom: "-12px", marginLeft: "-12px" }} />
                        ) : (
                          // Otherwise, keep the point preview
                          <span className={classes.displayedItem}>
                            {_.size(item) === 1 ?
                            <div className={"localizejs"}>{item[0]}</div>
                            :
                              item.map((i, iIndex) => (
                                <div key={iIndex} className={clsx(classes.bulletPoint, "localizejs")}>{i}</div>
                              ))
                            }
                          </span>
                        )
                      ) : typeof item === "object" && item !== null && item.tooltip && item.icon ? (
                        <Tooltip id="localizejs" title={item.tooltip} arrow>
                          <span className={clsx(classes.displayedItem, "localizejs")}>
                            <EAIcon icon={item.icon} style={{ width: "20px" }} />
                          </span>
                        </Tooltip>
                      ) : (typeof item === "object" && item !== null ? (
                        <DocViewerFromJson body={item} style={{ marginTop: "-12px", marginBottom: "-12px", marginLeft: "-12px" }} />
                      ) : (
                        <span className={clsx(classes.displayedItem, "localizejs")}>
                            {typeof item === "string" ? parse(item) : item}
                          </span>
                      ))}
                    </TableCell>
                  ))}
                </StyledTableRow>
              );
            })}
          </TableBody>
        </>
      ) : hideEmptyNotice ? <></> : (
        // Without datas
        <TableBody>
          <TableRow className={classes.tableRow}>
            <TableCell
              width={100}
              className={clsx(classes.tableCell, classes.centered)}
            >
              <span className={classes.noDataContent}>
                {i18next.t("none")}
              </span>
            </TableCell>
          </TableRow>
        </TableBody>
      )}
    </Table>
  );
};
export default DocViewerTable;
